import { useEffect, useState } from "react";

function pad(n) {
    return String(n).padStart(2, "0");
}

export function useMidnightCountdown() {
    const [t, setT] = useState({ h: "00", m: "00", s: "00" });
    useEffect(() => {
        const tick = () => {
            const now = new Date();
            const end = new Date(now);
            end.setHours(24, 0, 0, 0);
            const d = Math.max(0, end - now);
            setT({
                h: pad(Math.floor(d / 3.6e6)),
                m: pad(Math.floor((d % 3.6e6) / 6e4)),
                s: pad(Math.floor((d % 6e4) / 1e3)),
            });
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, []);
    return t;
}

export default function Countdown({ prefix = "countdown", className = "" }) {
    const t = useMidnightCountdown();
    const units = [
        [t.h, "Hours"],
        [t.m, "Minutes"],
        [t.s, "Seconds"],
    ];
    return (
        <div data-testid="countdown" className={`flex items-start gap-3 md:gap-4 ${className}`}>
            {units.map(([v, label], i) => (
                <div key={label} className="flex items-start gap-3 md:gap-4">
                    {i > 0 && <span className="pt-1 font-mono text-2xl text-gold">:</span>}
                    <div className="text-center">
                        <div
                            data-testid={`${prefix}-${label.toLowerCase()}`}
                            className="font-mono text-3xl md:text-4xl font-medium tabular-nums text-ink"
                        >
                            {v}
                        </div>
                        <div className="mt-1 text-[9px] font-mono uppercase tracking-[0.3em] text-mute">
                            {label}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
